import React from 'react';
import { Route, Routes } from 'react-router-dom';

import {
  CartScreen,
  ProductScreen,
  ProductScreenTecnologia,
  ProductIdScreen,
  ProductGalleryScreen,
  SigninScreen,
  RegisterScreen,
  ShippingAddressScreen,
  PaymentMethodScreen,
  PlaceOrderScreen,
  OrderScreen,
  CancelScreen,
  OrderHistoryScreen,
  PrivateRoute,
  ProfileScreen,
  Inicio,
} from '../../screen';

export default function MainContent() {
  return (
    <Routes>
      {/* <Route path="/cart/:id" element={<CartScreen />}></Route> */}
      <Route path="/cart/:id?" element={<CartScreen />}></Route>

      <Route path="/productos/plc" element={<ProductScreen />} />
      <Route path="/productos/tecnologia-hogar" element={<ProductScreenTecnologia />} />
      <Route path="/productos/:id" element={<ProductIdScreen />} />
      <Route
        path="/productos/:id/galeria"
        element={<ProductGalleryScreen />}
      />

      <Route path="/signin" element={<SigninScreen />}></Route>
      <Route path="/register" element={<RegisterScreen />}></Route>
      <Route path="/shipping" element={<ShippingAddressScreen />}></Route>
      <Route path="/payment" element={<PaymentMethodScreen />}></Route>
      <Route path="/placeorder" element={<PlaceOrderScreen />}></Route>
      <Route path="/order/:id" element={<OrderScreen />}></Route>
      <Route path="/cancel" element={<CancelScreen />}></Route>
      <Route path="/orderhistory" element={<OrderHistoryScreen />}></Route>
      <Route element={<PrivateRoute />}> </Route>
      <Route path="/profile" element={<ProfileScreen />}></Route>
      <Route path="/" element={<Inicio />}></Route>
    </Routes>
  );
}
